export const staticFieldLabels = {
    race: 'Race',
    // group: 'Group',
    // world: 'World',
    // game_master: 'Game Master',
    primary_class: 'Primary Class',
    primary_class_level: 'primary Class Level',
    alignment: 'Alignment',
    strength: 'Strength',
    Dexterity: 'Dexterity',
    intelligence: 'Intelligence',
    constitution: 'Constitution',
    wisdom: 'Wisdom',
    charisma: 'Charisma',
    Age: 'Age',
    sex: 'Sex',
    birthday: 'Birthday',
    pronouns: 'Pronouns',
    eyecolor: 'Eye Color',
    haircolor: 'Hair Color',
    hairstyle: 'Hair Style',
    geography: 'Geography',
    religion: 'Religion',
    physical :"Physical",
    speed: 'Speed',
    first_name: 'First Name',
    last_name: 'Last Name',
    clothing: 'Hat', 
    mantle: 'Mantle', 
    hat: 'Hat',    
    build: 'Build',
    walking_gate: 'Walking Gate',
    nickname: 'Nickname',
    title:'Title',
    suffix: 'Suffix',
    gamesystem: 'Game System',
    height:"Height (inches)",
    weight :"Weight",
    important_people: 'Important People',
    important_things: 'Important Things',
    strengths: 'Strengths',
    weaknesses: 'Weaknesses',
    SkillsTraits1: 'Skills/Traits 1',
    SkillsTraits2: 'Skills/Traits 2',
    SkillsTraits3: 'Skills/Traits 3',
    SkillsTraits4: 'Skills/Traits 4',
    backstory: 'Backstory',
    magic_strength: 'Magic Strength',
    magic_Dexterity: 'Magic Dexterity',
    magic_constitution: 'Magic Constitution',
    magic_wisdom: 'Magic Wisdom',
    magic_intelligence: 'Magic Intelligence',
    magic_charisma: 'Magic Charisma',
    // Add more form control names and their corresponding labels here
  };




  